import useMutationApi from 'src/api/useMutationApi';

interface SendEdi856TransactionParams {
  famousShipmentId: string;
  /** If true, allows resending even if already sent (for development/testing) */
  force?: boolean;
}

const useSendEdi856Transaction = (
  onSuccess?: () => void,
  onError?: () => void,
) => {
  return useMutationApi<SendEdi856TransactionParams>({
    endpoint: 'famous/shipments/send-edi-856',
    method: 'POST',
    options: {
      onSuccess,
      onError,
    },
  });
};

export default useSendEdi856Transaction;
